// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_hB","advertCardHeader__actions":"c-a_hC","advertCardHeader__bottomLabel":"c-a_hE"};